import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Delete, Edit, Add } from "@mui/icons-material";

const EditableShipmentTracker = () => {
  const [stages, setStages] = useState([
    {
      stage: "HQ to Midpoint",
      carrier: "Bus Cargo",
      trackingNumber: "123456",
      transportMode: "Bus",
      startLocation: "Warehouse HQ",
      endLocation: "Regional Office",
      startDate: "2024-12-01",
      endDate: "2024-12-03",
      status: "In Progress",
      notes: "Package delayed due to weather conditions",
      shipmentDocs: [
        { title: "Invoice", filePath: "/docs/invoice.pdf" },
        { title: "Manifest", filePath: "/docs/manifest.pdf" },
      ],
    },
  ]);

  const [openDialog, setOpenDialog] = useState(false);
  const [currentStage, setCurrentStage] = useState(null);
  const [editIndex, setEditIndex] = useState(-1);

  const handleDialogOpen = (stage, index) => {
    setCurrentStage(stage || {
      stage: "",
      carrier: "",
      trackingNumber: "",
      transportMode: "",
      startLocation: "",
      endLocation: "",
      startDate: "",
      endDate: "",
      status: "",
      notes: "",
      shipmentDocs: [],
    });
    setEditIndex(index);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setCurrentStage(null);
    setEditIndex(-1);
  };

  const handleSaveStage = () => {
    if (editIndex >= 0) {
      // Update existing stage
      setStages((prevStages) =>
        prevStages.map((stage, i) => (i === editIndex ? currentStage : stage))
      );
    } else {
      // Add new stage
      setStages((prevStages) => [...prevStages, currentStage]);
    }
    handleDialogClose();
  };

  const handleDeleteStage = (index) => {
    setStages((prevStages) => prevStages.filter((_, i) => i !== index));
  };

  return (
    <Box sx={{ maxWidth: 1200, margin: "0 auto", padding: "2rem" }}>
      <Card>
        <CardContent>
          <Typography variant="h4" gutterBottom>
             Shipment Tracker
          </Typography>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => handleDialogOpen(null, -1)}
            sx={{ marginBottom: "1rem" }}
          >
            Add New Stage
          </Button>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Stage</TableCell>
                  <TableCell>Carrier</TableCell>
                  <TableCell>Transport Mode</TableCell>
                  <TableCell>Start Location</TableCell>
                  <TableCell>End Location</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stages.map((stage, index) => (
                  <TableRow key={index}>
                    <TableCell>{stage.stage}</TableCell>
                    <TableCell>{stage.carrier}</TableCell>
                    <TableCell>{stage.transportMode}</TableCell>
                    <TableCell>{stage.startLocation}</TableCell>
                    <TableCell>{stage.endLocation}</TableCell>
                    <TableCell>{stage.status}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => handleDialogOpen(stage, index)}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteStage(index)}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>

      {/* Dialog for Adding/Editing Stages */}
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>{editIndex >= 0 ? "Edit Stage" : "Add New Stage"}</DialogTitle>
        <DialogContent>
          {[
            { label: "Stage", value: "stage" },
            { label: "Carrier", value: "carrier" },
            { label: "Tracking Number", value: "trackingNumber" },
            { label: "Transport Mode", value: "transportMode" },
            { label: "Start Location", value: "startLocation" },
            { label: "End Location", value: "endLocation" },
            { label: "Status", value: "status" },
            { label: "Notes", value: "notes" },
          ].map((field) => (
            <TextField
                key={field.value}
                margin="dense"
                label={field.label}
                fullWidth
                value={currentStage?.[field.value] || ""}
                onChange={(e) =>
                    setCurrentStage((prev) => ({
                    ...prev,
                    [field.value]: e.target.value,
                    }))
                }
                />

          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button onClick={handleSaveStage} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default EditableShipmentTracker;
